var e, t;
function i() {
  if (t) return e;
  t = 1;
  function r() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return e = r, e;
}
export {
  i as __require
};
//# sourceMappingURL=gzheader.es.js.map
